import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { useFeatureSubscriptionConfig } from '@frontend/self-upgrade';

type UseIsPAEligibleAccount = {
  isLoading?: boolean;
  isPAEligibleAccount?: boolean;
};

const PA_ACTIVE_STATES = [State.ACTIVE, State.PROMOTE]; // ACTIVE and PROMOTE states are considered active for Practice Analytics

// This is used in the Analytics app to determine if the location is eligible for the Practice Analytics feature.
export const useIsPAEligibleAccount = (): UseIsPAEligibleAccount => {
  const { isLoading, isFeatureActiveInSomeLocations, isUpgradeOrTrialEligible } = useFeatureSubscriptionConfig({
    feature: Feature.PRACTICE_ANALYTICS,
    checkBundleUpgrade: false,
    activeStates: PA_ACTIVE_STATES,
  });

  const isPAEligibleAccount = isFeatureActiveInSomeLocations || isUpgradeOrTrialEligible;

  return {
    isPAEligibleAccount,
    isLoading,
  };
};
